/** Default signed-in destination. It must exist when redesign flags are disabled to avoid catch-all loops. */

export const PATIENTS_ROUTE = "/pages/patients";

export function landingRoute(): string {
  return PATIENTS_ROUTE;
}
